import { Play } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const RunIcon = createLucideIcon(Play);
